import { createSlice } from "@reduxjs/toolkit";
// this code for slice value for add strategies
export const AddStrategies = createSlice({
  name: "AddStrategies",
  initialState: {
    api_completed: false,
    isLoading: false,
    isSuccess: false,
    isFirst: true,
    switchResponse: false,
    data: [],
  },
  reducers: {
    add_AddStrategies: (state, _) => {
      state.isLoading = true;
    },
    success_api_call_add_AddStrategies: (state, action) => {
      state.data = action.payload;
      state.isLoading = false;
      state.isSuccess = true;
      state.api_completed = true;
      state.isFirst = true;
      state.switchResponse = true;

    },
    failure_api_call_add_AddStrategies: (state, action) => {
      state.isLoading = false;
      state.data = action.payload;
      state.isSuccess = false;
      state.api_completed = true;
      state.switchResponse = true;

    },
    add_AddStrategies_is_success: (state, action) => {
      state.isSuccess = false;
    },
    create_AddStrategies_complete_api: (state, action) => {
      state.api_completed = false;
    },
    false_switchStrategies_response: (state) => {
      state.switchResponse = false;
    },
  },
});
export default AddStrategies.reducer;
export const {
  add_AddStrategies,
  success_api_call_add_AddStrategies,
  failure_api_call_add_AddStrategies,
  create_AddStrategies_complete_api,
  add_AddStrategies_is_success,
  false_switchStrategies_response
} = AddStrategies.actions;
